import { useEventBus } from '@vueuse/core'

export const svg2canvas = async (svgTag) => {
  const useTags = svgTag.getElementsByTagName('use')
  if (!useTags.length) return

  const useTag = useTags[0].href.baseVal
  const useId = useTag.split('-')[1]
  const useValue = require(`base/icons/svg/${useId}.svg`)

  const svgW = svgTag.scrollWidth
  const svgH = svgTag.scrollHeight
  const parentNode = svgTag.parentNode

  const img = new Image()
  if (useValue.default.url) {
    img.src = `${process.env.VUE_APP_CDN}${useValue.default.url.slice(1)}`
  } else {
    const svg = useValue.default.content.replace(/symbol/g, 'svg')
    const blob = new Blob([svg], { type: 'image/svg+xml' })
    img.src = URL.createObjectURL(blob)
  }
  img.crossOrigin = ''

  img.onload = () => {
    const canvas = document.createElement('canvas')
    canvas.setAttribute('width', svgW)
    canvas.setAttribute('height', svgH)
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, svgW, svgH)
    parentNode.removeChild(svgTag)
    parentNode.insertAdjacentElement('afterBegin', canvas)
    useEventBus('svgDrawEnd').emit()
  }

  img.onerror = () => {
    useEventBus('svgDrawEnd').emit()
  }
}
